import { gql } from "@apollo/client";

export const DELETE_CHAT = gql`
    mutation deleteChat($chatId: ID!) {
        deleteChat(chatId: $chatId) {
            message
            success
        }
    }
`;